(function() {
    'use strict';

    angular.module('swif.openbase')
    .service('swifOpenbaseKeysService', swifOpenbaseKeysService)
    .service('swifOpenbaseKeyMovesService', swifOpenbaseKeyMovesService)
    .directive('keysTable', keysTable)
    .controller('OpenbaseKeysModalController', OpenbaseKeysModalController)
    .component('keyMoves', {
        templateUrl: 'partials/openbase/keys_move_table_directive.html',
        controller: KeyMovesController,
        bindings: {
            'keyId': '<'
        }
    });

    /**
        * @ngdoc service
        * @name swif.patrimoine.swifOpenbaseKeysService
        * @requires swif.framework.swifFrameworkService
    **/
    function swifOpenbaseKeysService(swifFrameworkService) {
        'ngInject';

        var swif = swifFrameworkService;
        var service = {};

        function getModuleFilter(module) {
            var filter = {};
            if (module === 'parcauto') {
                swif.data.addExtraFilter(filter, 'key', 'equipment_id.categ_id.is_vehicle', '=', true);
            } else if (module === 'publicLightning') {
                swif.data.addExtraFilter(filter, 'key', 'equipment_id.categ_id.is_streetlight', '=', true);
            } else if (module === 'openresa') {
                filter.fields = ["id", "active", "category_id", "actions", "name", "site_ids", "site_names", "equipment_id", "storage_site", "storage_equipment", "holder_contact", "people_name", "people_phone", "ref", "default_code", "state", "booking_request_ids"];
                swif.data.addExtraFilter(filter, 'key', 'booking_request_ids', '!=', false);
            }
            return filter;
        };

        service.resolveData = function (moduleName) {
            var filter = getModuleFilter(moduleName);
            return swif.route.check().then(function () {
                return service.createCollection(undefined, filter).then(function (collection) {
                    return collection;
                });
            });
        };
        service.createCollection = function(selectedSiteId, filter) {
            var _filter = filter || {};
            return swif.collections.createOrUpdate('keys', 'key', _filter)
            .then(function(collection) {
                return collection;
            });
        }
        service.getCollection = function() {
            return swif.collections.getCollection('keys');
        };
        service.preValidate = function(data) {
            return service.getCollection().preValidate(data);
        }
        service.callback = function(error, data) {
            return service.getCollection().defaultActionCallback(error, data);
        }
        return service;
    }

    function swifOpenbaseKeyMovesService(swifFrameworkService) {
        'ngInject';

        var swif = swifFrameworkService;
        var service = {};

        service.createCollection = function(keyId) {
            var filter = {};
            filter.fields = ['id', 'date', 'holder_contact', 'type', 'people_name', 'people_phone'];
            swif.data.sortOn(filter, 'date', 'DESC');
            swif.data.setLimit(filter, 10);
            swif.data.addExtraFilter(filter, 'key', 'key_id', '=', keyId);
            return swif.collections.createOrUpdate('keyMoves', 'key_move', filter);
        }
        service.getCollection = function() {
            return swif.collections.getCollection('keyMoves');
        };
        service.preValidate = function(data) {
            /*
             * Ensure the key moves collection is created :
             * a move can be created without opening key moves table (by clicking the key line).
             * In this case, we create a collection to have the preValidate method.
            */
            if (_.isUndefined(service.getCollection())) {
                service.createCollection();
            }
            return service.getCollection().preValidate(data);
        }
        service.callback = function(error, data) {
            // Reset action id to be able to automatically refresh after move creation
            data.action.id = 'add';
            var callback = service.getCollection().defaultActionCallback(error, data);
            data.action.id = 'move_key';
            return callback;
        }
        return service;
    }

    /**
     * @ngdoc directive
     * @name swif.openbase.keysTable
     * @module swif.openbase
     * @restrict A
     * @description display a table of keys with move actions
     * @usage
     * <keys-table ng-model="keysArrayOfObjects"
     *              pre-modal="keysPreModal"
     *              pre-validate="keysPreValidate"
     *              callback="keysCallback"
     *              move-pre-validate="keyMovePreValidate"
     *              move-callback="keyMoveCallback"
     */
    function keysTable() {
        return {
            restrict: 'E',
            templateUrl: 'partials/openbase/keys_table.html',
            require: 'ngModel',
            scope: {
                preModal: '=',
                preValidate: '=',
                callback: '=',
                movePreValidate: '=',
                moveCallback: '=',
                resaColumn: '=?'
            },
            link: function(scope, element, attr, ngModel) {
                ngModel.$render = function() {
                    scope.keys = ngModel.$viewValue;
                };

                scope.getResaUrl = function(resaId) {
                    if (resaId) {
                        var domain = '{"domain":[["id","=","'+resaId+'"]]}';
                        var encodedDomain = encodeURIComponent(domain);
                        return '/#/reservations/reservations/table_view?c:reservationRequests='+encodedDomain;
                    }
                    return '';
                }
            }
        }
    }

    function OpenbaseKeysModalController($scope, openbase, swifFrameworkService) {
        'ngInject';
        var swif = swifFrameworkService;

        if (!$scope.model.holder_contact && !$scope.model.people_name && !$scope.model.people_phone) {
            $scope._external = false;
        } else if ($scope.model.people_name || $scope.model.people_phone) {
            $scope._external = true;
        }

        $scope.$watch('_external', newV => {
            if (newV === true) {
                delete $scope.model.holder_contact;
            } else {
                delete $scope.model.people_name;
                delete $scope.model.people_phone;
            }
        });

        $scope.formatNameChoices = openbase.utils.selectOneFormatNameChoice;
        $scope.filter = {};
        $scope.storageType = $scope.model._storageType || 'site';
        $scope.equipmentFilter = $scope.model._equipmentFilter || {
            fields:  ["id", "name", "complete_name", "equipment_reference", "is_active"]
        };
        $scope.changeProductType = function(type, isStorage) {
            if (isStorage == true) {
                $scope.storageType = type;
                if (type === 'site') {
                    $scope.model.storage_equipment = false;
                } else if (type === 'equipment') {
                    $scope.model.storage_site = false;
                }
            } else {
                $scope.model._type = type;
                if (type === 'site') {
                    $scope.model.equipment_id = false;
                } else if (type === 'equipment') {
                    $scope.model.site_ids = false;
                }
            }
        }
    }

    function KeyMovesController(swifFrameworkService, swifOpenbaseKeyMovesService) {
        'ngInject';

        var $ctrl = this;
        var swif = swifFrameworkService;
        var service = swifOpenbaseKeyMovesService;

        function initialize() {
            service.createCollection($ctrl.keyId)
            .then(function(collection) {
                $ctrl.keyMoves = collection;
            });
        }
        initialize();
    }
})();
